// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"1b0742a2","77":"62bfeb5a","78":"b8557b9e","234":"598604fe","281":"ad99a3a1","335":"6212d426","381":"4f8a9b06","453":"f94d9780","765":"1e87eb84"}[chunkId] + ".chunk.js";
};